export default __webpack_public_path__ + "static/media/person-info.7882b738.svg";